export const mockImages = 
    [
        {
           "idImage":1,
            "type":"image",
            "isSquare":false,
            "left":13.5,
            "top":17,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
        },
        {
            "idImage":2,
            "type":"image",
            "isSquare":false,
            "left":10.200000000000003,
            "top":209.5,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
        },
        {
            "idImage":3,
            "type":"image",
            "isSquare":false,
            "left":14,
            "top":401,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
        },
        {
            "idImage":4,
            "type":"image",
            "isSquare":false,
            "left":224,
            "top":16.407349081364842,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
        },
        {
            "idImage":5,
            "type":"image",
            "isSquare":false,
            "left":231,
            "top":211,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
        },{
            "idImage":6,
            "type":"image",
            "isSquare":false,
            "left":209,
            "top":395,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
         }
    ]

 export const mockImages6 = 
    [
        {
           "idImage":1,
            "type":"image",
            "isSquare":false,
            "left":13.5,
            "top":17,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
        },
        {
            "idImage":2,
            "type":"image",
            "isSquare":false,
            "left":10.200000000000003,
            "top":209.5,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
        },
        {
            "idImage":3,
            "type":"image",
            "isSquare":false,
            "left":14,
            "top":401,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
        },
        {
            "idImage":4,
            "type":"image",
            "isSquare":false,
            "left":224,
            "top":16.407349081364842,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
        },
        {
            "idImage":5,
            "type":"image",
            "isSquare":false,
            "left":231,
            "top":211,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
        },{
            "idImage":6,
            "type":"image",
            "isSquare":false,
            "left":225,
            "top":402,
            "scaleX":0.094,
            "scaleY":0.132,
            "width":1920,
            "height":1280,
            "angle":0
    }
]

export const mockImages8 = 
[
    {
       "idImage":1,
        "type":"image",
        "isSquare":false,
        "left":13.5,
        "top":17,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    },
    {
        "idImage":2,
        "type":"image",
        "isSquare":false,
        "left":10.200000000000003,
        "top":209.5,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    },
    {
        "idImage":3,
        "type":"image",
        "isSquare":false,
        "left":14,
        "top":401,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    },
    {
        "idImage":4,
        "type":"image",
        "isSquare":false,
        "left":224,
        "top":16.407349081364842,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    },
    {
        "idImage":5,
        "type":"image",
        "isSquare":false,
        "left":231,
        "top":211,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    },{
        "idImage":6,
        "type":"image",
        "isSquare":false,
        "left":225,
        "top":402,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    },{
        "idImage":7,
        "type":"image",
        "isSquare":false,
        "left":225,
        "top":402,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    },{
        "idImage":8,
        "type":"image",
        "isSquare":false,
        "left":225,
        "top":402,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    }
]

export const mockImages4 = 
[
    {
       "idImage":1,
        "type":"image",
        "isSquare":false,
        "left":13.5,
        "top":17,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    },
    {
        "idImage":2,
        "type":"image",
        "isSquare":false,
        "left":10.200000000000003,
        "top":209.5,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    },
    {
        "idImage":3,
        "type":"image",
        "isSquare":false,
        "left":14,
        "top":401,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    },
    {
        "idImage":4,
        "type":"image",
        "isSquare":false,
        "left":224,
        "top":16.407349081364842,
        "scaleX":0.094,
        "scaleY":0.132,
        "width":1920,
        "height":1280,
        "angle":0
    }
]


export const importMockImage = (length) => {

    if(parseInt(length) === 6){
        return mockImages6
    }

    if(parseInt(length) === 8){
        return mockImages8
    }

    if(parseInt(length) === 4){
        return mockImages4
    }

}